import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import { colors } from 'theme/colors';

export const StyledPaymentWrapper = styled(Grid)`
  background-color: ${colors.white};
  border: 1px solid ${colors.blue100};
  border-radius: 4px;
  padding: 20px 20px 40px;

  & > div > h5 {
    font-weight: bold;
    margin-bottom: 20px;
  }
`;

export const StyledPaymentInfoWrapper = styled(Grid)`
  padding: 10px 20px;
  background: #ffffff;
  border: 1px solid ${colors.blue50};
  border-radius: 4px;

  & span {
    font-family: NotoSansRegular, sans-serif;
    padding-left: 6px;
    line-height: 32px;
  }
`;

export const StyledPaymentDetailsWrapper = styled(Grid)`
  margin-top: 20px;
  padding: 20px;
  gap: 10px;
  background-color: ${colors.blue50};
  border-radius: 4px;
  margin-bottom: 20px;

  h5 {
    font-weight: bold;
    margin: 8px 0;
  }
  & span {
    font-family: NotoSansRegular, sans-serif;
    padding-left: 6px;
    line-height: 32px;
  }
`;
